import production from './configureStore.production';
import development from './configureStore.development';

const getStore = (env) =>
  ({
    development,
    production,
  }[env] || production);

export const configureStore = getStore(process.env.NODE_ENV);
